import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <section className="portal-section-card">
      <h3>Pagina nao encontrada</h3>
      <p className="portal-muted">A rota solicitada nao existe neste portal.</p>
    </section>
  );
};

export default NotFoundPage;
